module.exports = __webpack_public_path__ + "static/img/help.4a895d00.svg";